import { Modal } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FactorTeacherForm } from '../forms/FactorTeacherForm';

type FactorTeacherModalProps = {
  selectedFactorUuid: string | null;
  isOpen: boolean;
  onClose: () => void;
};

export const FactorTeacherModal = ({ selectedFactorUuid, isOpen, onClose }: FactorTeacherModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal
      loading={loading}
      title={selectedFactorUuid ? t('factors.editTeacherFactor') : t('factors.addTeacherFactor')}
      isOpen={isOpen}
      onRequestClose={onClose}
    >
      <FactorTeacherForm selectedFactorUuid={selectedFactorUuid} onLoad={setLoading} onClose={onClose} />
    </Modal>
  );
};
